export const RESUMES = [
  {
    id: 0,
    title: '가천대학교 졸업인증 기록 시스템 Gradu',
    date: '2023.05 - ',
    contribution: '기여한 점',
    contents: [
      {
        subTitle: '[ 기술 ]',
        elements: [
          'Next.js, Typescript, Styled-Component, Redux-Toolkit',
          '유저, 관리자 페이지 구현',
          '렌더링 최적화를 통한 성능 개선',
          'UI/UX 향상을 위한 작업',
          '반응형 홈페이지',
        ],
      },
      {
        subTitle: '[ 협업 / 소통 ]',
        elements: [
          '리더 역할',
          'Github Issue, PR 컨벤션 도입',
          '일정 산출, 조율 및 관리',
          'PR 리뷰를 통한 생산성 향상',
          '매일 1시간의 스크럼을 통해 생산성 향상',
        ],
      },
    ],
  },
  {
    id: 1,
    title: 'IT 학술동아리 Leets 홈페이지 제작',
    date: '2023.02 - ',
    contribution: '기여한 점',
    contents: [
      {
        subTitle: '[ 기술 ]',
        elements: [
          'Next.js, Typescript, Styled-Component, Redux-Toolkit',
          '유저, 관리자 페이지 구현',
          '렌더링 최적화를 통한 성능 개선',
          'UI/UX 향상을 위한 작업',
          'React에서 Next.js로 마이그레이션',
          'Javascript에서 Typescript로 마이그레이션',
          'LightHouse 성능/접근성/권장사항/검색엔진 최적화 각 100/94/100/100점',
          '반응형 홈페이지',
        ],
      },
      {
        subTitle: '[ 주도적 자세 / 학습 ]',
        elements: [
          '동아리 창설',
          '더 나은 환경을 구성하기 위해 인원 모집',
          '교내 유일의 홈페이지가 있는 동아리',
        ],
      },
      {
        subTitle: '[ 경험 ]',
        elements: [
          '160여명의 지원서, 60명의 면접 진행',
          '조직을 효율적으로 이끌었던 노하우',
        ],
      },
    ],
  },
  {
    id: 2,
    title: 'Leets UI 라이브러리 제작',
    date: '2023.12 - ',
    contribution: '기여한 점',
    contents: [
      {
        subTitle: '[ 기술 ]',
        elements: [
          'Next.js, Typescript, Styled-Component, Redux-Toolkit',
          '유저, 관리자 페이지 구현',
          '렌더링 최적화를 통한 성능 개선',
          'UI/UX 향상을 위한 작업',
          'React에서 Next.js로 마이그레이션',
          'Javascript에서 Typescript로 마이그레이션',
          'LightHouse 성능/접근성/권장사항/검색엔진 최적화 각 100/94/100/100점',
          '반응형 홈페이지',
        ],
      },
      {
        subTitle: '[ 시스템 구축 ]',
        elements: [
          '일관적인 디자인을 통한 아이덴티티 강화',
          'UI/UX 경험 향상',
          '동아리원이 디자인에 고민하는 시간 감소',
        ],
      },
      {
        subTitle: '[ 경험 ]',
        elements: ['오픈소스 라이브러리 경험', '실제 라이브러리 배포'],
      },
    ],
  },
];
